import React, { Component } from "react";
import ReactDOM from "react-dom";
import { Card, CardMedia, CardContent, Typography, CardActions, Button } from "@mui/material";

import Text from "../../components/Text";

import env from "../../../env";

import "./News.styl";
import Screen from "../../components/Screen";

class News extends Component {
    displayName = News.name;

    titles = [];
    sources = [];
    descriptions = [];

    news = [
        {
            highlight: false,
            image: env.images.news.aracaju_1,
            link: "http://minutosergipe.com.br/?p=41672",
            source: "Minuto Sergipe",
            title: "Prefeitura de Aracaju recompõe quase 30 mil luminárias em 2018",
            description: "...O secretário municipal da Infraestrutura, Sérgio Ferrari, acredita que o serviço está conseguindo atender as solicitações chegadas e em tempo relativamente rápido. “Em média, foram registradas mais de duas mil lâmpadas trocadas a cada mês e em tempo que, no máximo, chegava a 72 horas, o que é algo considerável para uma cidade como Aracaju."
        },
        {
            highlight: true,
            image: env.images.news.mogiDasCruzes_1,
            link: "http://g1.globo.com/sp/mogi-das-cruzes-suzano/noticia/2016/05/mogi-recebe-reclamacoes-sobre-energia-eletrica-atraves-de-aplicativo.html",
            source: "Globo G1",
            title: "Mogi recebe reclamações sobre energia elétrica através de aplicativo",
            description: "Quem tiver problemas com o fornecimento de energia elétrica em Mogi das Cruzes agora pode optar por uma nova ferramenta para fazer reclamações. Além do Ilumina Mogi, pelo telefone 156, da Ouvidoria Municipal, e do Site da Prefeitura, agora a população pode cadastrar reclamações pelo contato Geolux, por meio do aplicativo Telegram para smartphones, que é gratuito."
        },
        {
            highlight: false,
            image: env.images.news.mogiDasCruzes_2,
            link: "https://globoplay.globo.com/v/4979443/",
            source: "Globo Play",
            title: "Moradores de Mogi poderão denunciar falta de luz através de aplicativo",
            description: "Aplicativo de smartphone deve facilitar registro das reclamações."
        },
        {
            highlight: true,
            image: env.images.news.colombo_1,
            link: "http://portal.colombo.pr.gov.br/aplicativo-permite-que-moradores-colaborem-na-manutencao-da-iluminacao-publica/",
            source: "Portal Colombo",
            title: "APLICATIVO PERMITE QUE MORADORES COLABOREM NA MANUTENÇÃO DA ILUMINAÇÃO PÚBLICA",
            description: "O morador que precisar pedir a manutenção da iluminação pública em Colombo pode contar com tecnologia digital. A Prefeitura Municipal por meio da Secretaria de Obras e Viação, em parceria com a empresa de iluminação pública, Geolux disponibiliza a população um novo meio para cadastrar os pedidos de reparos na iluminação do município."
        },
        {
            highlight: false,
            image: env.images.news.paranagua_1,
            link: "http://www.paranagua.pr.gov.br/noticias.php?noticia_id=12504",
            source: "Prefeitura de Paranaguá",
            title: "“Fique Ligado!”: Prefeitura realiza campanha para agilizar solução de reparos na iluminação pública",
            description: "...O secretário municipal de Serviços Urbanos, Ícaro Wolski explica que quando ocorrerem problemas relacionados a iluminação pública, o cidadão poderá abrir o protocolo por telefone ou internet ou via aplicativo e deverá ter em mãos a localização do poste."
        },
        {
            highlight: false,
            image: env.images.news.indaiatuba_1,
            link: "https://www.indaiatuba.sp.gov.br/relacoes-institucionais/imprensa/noticias/27233/",
            source: "Prefeitura de Indaiatuba",
            title: "Indaiatuba ganha novos canais para solicitação de reparos na iluminação pública",
            description: "A Prefeitura de Indaiatuba está com novos canais de comunicação para que a população possa solicitar reparos na iluminação pública. A novidade é que os problemas com lâmpadas apagadas agora podem ser comunicados por meio do aplicativo Telegram para smartphones pelo contato Geolux.",
        },
        {
            highlight: false,
            image: env.images.news.jandira_1,
            link: "http://www.jandira.sp.gov.br/news.php?id=69",
            source: "Prefeitura de Jandira",
            title: "Jandira disponibiliza serviços de reparos na iluminação pública a moradores",
            description: "[...] Para realizar o pedido por celular, o morador deve baixar o aplicativo Telegram – que é semelhante ao WhatsApp. Dentro do aplicativo, toque na lupa no canto superior direito da tela e digite ‘Geolux’. Na sequência, toque em ‘Começar’ e informe a localização da rua com problemas de iluminação pública.",
        },
    ];

    normalizeHeight = (itemArray) => {
        let maxHeight = 0;
        itemArray.forEach(item => {
            let domNode = ReactDOM.findDOMNode(item);
            domNode.style.height = "";
            maxHeight = Math.max(maxHeight, domNode.offsetHeight);
        });
        itemArray.forEach(item => {
            ReactDOM.findDOMNode(item).style.height = `${maxHeight}px`;
        });
    }

    getChunkSize = (viewportType) => {
        if (viewportType === Screen.VIEWPORT_TYPES.CELLPHONE_LARGE) return 1;
        if (viewportType === Screen.VIEWPORT_TYPES.TABLET || viewportType === Screen.VIEWPORT_TYPES.NOTEBOOK) return 2;
        return 3;
    }

    normalizeHeights = (viewportType) => {
        let chunkSize = this.getChunkSize(viewportType);
        Array.chunk(this.titles, chunkSize).forEach(chunk => this.normalizeHeight(chunk));
        Array.chunk(this.sources, chunkSize).forEach(chunk => this.normalizeHeight(chunk));
        Array.chunk(this.descriptions, chunkSize).forEach(chunk => this.normalizeHeight(chunk));
    }

    componentDidMount() {
        Screen.addViewportTypeListener(this.normalizeHeights);
        this.normalizeHeights(Screen.getViewportType());
    }

    componentWillUnmount() {
        Screen.removeViewportTypeListener(this.normalizeHeights);
    }

    render() {
        return (
            <div tabIndex={0} aria-label="Conteúdo da página de notícias" className="News">
                <section aria-label="Seção de notícias">
                    <Text as="h1" className="header align-center">Veja notícias de cidades que utilizam o Geolux</Text>
                    <div className="grid">
                    {
                        this.news.map((news, index) => (
                            <Card key={index} className="news-card">
                                <CardMedia className="news-card-image" image={news.image} title={news.title} />
                                <CardContent className="news-card-content">
                                    <Typography ref={(elem) => this.titles.push(elem)} tabIndex={0} className="news-card-title" gutterBottom variant="h5" component="h2">{news.title}</Typography>
                                    <Typography ref={(elem) => this.sources.push(elem)} tabIndex={0} className="news-card-source" variant="subtitle1" color="textSecondary">{news.source}</Typography>
                                    <Typography ref={(elem) => this.descriptions.push(elem)} tabIndex={0} className="news-card-description" component="p">{news.description}</Typography>
                                </CardContent>
                                <CardActions className="news-card-actions">
                                    <Button className="button" component="a" href={news.link} target="_blank" rel="external nofollow" size="small">Ler mais</Button>
                                </CardActions>
                            </Card>
                        ))
                    }
                    </div>
                </section>
            </div>
        );
    }
}

export default News;
